
import article0 from './Best_Practices_and_Limitations/Database_Product/Best_Practices_and_Limitations';
import article1 from './Best_Practices_and_Limitations/Database_Product/MongoDB_Encryption_Limitations';
import article2 from './Best_Practices_and_Limitations/OnData_SecureFile/Best_Practices_and_Limitations';
import article3 from './How-to_Guides/Backup_and_Validation/DB2';
import article4 from './How-to_Guides/Backup_and_Validation/MariaDB';
import article5 from './How-to_Guides/Backup_and_Validation/Microsoft SQL Server';
import article6 from './How-to_Guides/Backup_and_Validation/MySQL';
import article7 from './How-to_Guides/Backup_and_Validation/Oracle';
import article8 from './How-to_Guides/Backup_and_Validation/PostgreSQL';
import article9 from './How-to_Guides/Backup_and_Validation/Snowflake';
import article10 from './How-to_Guides/Database_Download/Download Databases';
import article11 from './How-to_Guides/Drivers/Apply_Encryption_Setting_Changes';
import article12 from './How-to_Guides/Drivers/Client_Access_Control';
import article13 from './How-to_Guides/Drivers/Client_Registration';
import article14 from './How-to_Guides/Drivers/OnData ODBC Driver';
import article15 from './How-to_Guides/Drivers/OnData_JDBC';
import article16 from './How-to_Guides/Drivers/OnData_SqlClient';
import article17 from './How-to_Guides/Encryption/Data_Information_Types';
import article18 from './How-to_Guides/Encryption/Encryption_Rules';
import article19 from './How-to_Guides/Encryption/Encryption_Tool';
import article20 from './How-to_Guides/Encryption/Encryption_Tool_V2';
import article21 from './How-to_Guides/Encryption/Steps to Encrypt SQL Server Database';
import article22 from './How-to_Guides/Portal_Configuration/Configuring_Roles_In_Entra_ID';
import article23 from './How-to_Guides/Portal_Configuration/Custom_Cloud_Subscription';
import article24 from './How-to_Guides/Portal_Configuration/Data_Access_Roles';
import article25 from './How-to_Guides/Portal_Configuration/Microsoft_Entra_ID_Integration';
import article26 from './How-to_Guides/Portal_Configuration/OnData_Application_Roles';
import article27 from './How-to_Guides/Portal_Configuration/Use_Custom_Key_Vault';
import article28 from './How-to_Guides/SecureFile/Classification_and_Protection_Rules';
import article29 from './How-to_Guides/SecureFile/Deploy_Data_Analyzer';
import article30 from './How-to_Guides/SecureFile/Document_Types';
import article31 from './How-to_Guides/SecureFile/File_Information_Types';
import article32 from './How-to_Guides/SecureFile/Install_SecureFile';
import article33 from './How-to_Guides/SecureFile/SecureFile_Settings';
import article34 from './How-to_Guides/SecureFile/Sharing_Files_with_External_Users';
import article35 from './How-to_Guides/SecureFile/Silent_Installation_and_Registration';
import article36 from './How-to_Guides/SecureFile/Using_SecureFile';
import article37 from './Release_Notes/Release_1.1.33';
import article38 from './Release_Notes/Release_2.0.48';
import article39 from './Release_Notes/Release_2.1.57';

const docMap = {
  '/best_practices_and_limitations/database_product/best_practices_and_limitations': article0,
  '/best_practices_and_limitations/database_product/mongodb_encryption_limitations': article1,
  '/best_practices_and_limitations/ondata_securefile/best_practices_and_limitations': article2,
  '/how-to_guides/backup_and_validation/db2': article3,
  '/how-to_guides/backup_and_validation/mariadb': article4,
  '/how-to_guides/backup_and_validation/microsoft sql server': article5,
  '/how-to_guides/backup_and_validation/mysql': article6,
  '/how-to_guides/backup_and_validation/oracle': article7,
  '/how-to_guides/backup_and_validation/postgresql': article8,
  '/how-to_guides/backup_and_validation/snowflake': article9,
  '/how-to_guides/database_download/download databases': article10,
  '/how-to_guides/drivers/apply_encryption_setting_changes': article11,
  '/how-to_guides/drivers/client_access_control': article12,
  '/how-to_guides/drivers/client_registration': article13,
  '/how-to_guides/drivers/ondata odbc driver': article14,
  '/how-to_guides/drivers/ondata_jdbc': article15,
  '/how-to_guides/drivers/ondata_sqlclient': article16,
  '/how-to_guides/encryption/data_information_types': article17,
  '/how-to_guides/encryption/encryption_rules': article18,
  '/how-to_guides/encryption/encryption_tool': article19,
  '/how-to_guides/encryption/encryption_tool_v2': article20,
  '/how-to_guides/encryption/steps to encrypt sql server database': article21,
  '/how-to_guides/portal_configuration/configuring_roles_in_entra_id': article22,
  '/how-to_guides/portal_configuration/custom_cloud_subscription': article23,
  '/how-to_guides/portal_configuration/data_access_roles': article24,
  '/how-to_guides/portal_configuration/microsoft_entra_id_integration': article25,
  '/how-to_guides/portal_configuration/ondata_application_roles': article26,
  '/how-to_guides/portal_configuration/use_custom_key_vault': article27,
  '/how-to_guides/securefile/classification_and_protection_rules': article28,
  '/how-to_guides/securefile/deploy_data_analyzer': article29,
  '/how-to_guides/securefile/document_types': article30,
  '/how-to_guides/securefile/file_information_types': article31,
  '/how-to_guides/securefile/install_securefile': article32,
  '/how-to_guides/securefile/securefile_settings': article33,
  '/how-to_guides/securefile/sharing_files_with_external_users': article34,
  '/how-to_guides/securefile/silent_installation_and_registration': article35,
  '/how-to_guides/securefile/using_securefile': article36,
  '/release_notes/release_1.1.33': article37,
  '/release_notes/release_2.0.48': article38,
  '/release_notes/release_2.1.57': article39,
}

export default docMap;
